import React from 'react'
import makeStyles from '@mui/styles/makeStyles'
import { format, startOfWeek, addDays } from 'date-fns'
import Typography from '@mui/material/Typography'


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },
  cell: {
    width: props => props.width / 7,
    height: 40,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  text: {
    color: theme.palette.primary.grey
  }
}))


const CalendarDayNames = props => {
  const { date, containerWidth } = props
  const classes = useStyles({ width: containerWidth })
  const weekdayFormat = 'EEE'
  const startDay = startOfWeek(date)
  const days = [0, 0, 0, 0, 0, 0, 0]



  return (
    <div className={ classes.root }>
      { days.map((_, i) => {
          const string = format(addDays(startDay, i), weekdayFormat)
          
          return (
            <div className={ classes.cell } key={ i }>
              <Typography className={ classes.text }>
                { string }
              </Typography>
            </div>
          )
      })}
    </div>
  )
}

export default CalendarDayNames